__turbopack_context__.v({
  "button": "Tx-efa_button",
  "container": "Tx-efa_container",
  "disabled": "Tx-efa_disabled",
  "isSelected": "Tx-efa_isSelected",
  "item": "Tx-efa_item",
  "list": "Tx-efa_list",
  "shadow--none": "Tx-efa_shadow--none",
  "size--sm": "Tx-efa_size--sm",
  "textStyle--heading": "Tx-efa_textStyle--heading",
  "width--maxcontent": "Tx-efa_width--maxcontent",
});
